import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';
import { API_ROUTES } from '@/constants/routes';
import { WORKER_KEYS } from './useWorkerProfile';
import type { Job, PaginatedResponse } from '@/types/worker';

interface FeedParams {
    profession?: string;
    quality_tier?: string;
    limit?: number;
    offset?: number;
}

export const useFeed = (params: FeedParams = {}) => {
    const queryParams: Record<string, string> = {};
    if (params.profession) queryParams.profession = params.profession;
    if (params.quality_tier) queryParams.quality_tier = params.quality_tier;
    if (params.limit) queryParams.limit = String(params.limit);
    if (params.offset) queryParams.offset = String(params.offset);

    return useQuery({
        queryKey: WORKER_KEYS.feed(queryParams),
        queryFn: async (): Promise<PaginatedResponse<Job>> => {
            const { data } = await api.get(API_ROUTES.workerFeed, { params: queryParams });
            return data;
        },
        staleTime: 30 * 1000,
    });
};
